export const setUserDetails = (data) => {
    localStorage.setItem("user_Details", data);
  }
  
  export const getUserDetails = () => {
    return JSON.parse(localStorage.getItem("user_Details")) || null;
  }